
import { Component, Prop, Vue } from 'vue-property-decorator';
import PostalAddress from 'i18n-postal-address';
import { SapCustomerPartner } from '@/api/model/sap-customer-partner';

@Component
export default class ShipToAddress extends Vue {
  @Prop(Object)
  shipTo!: SapCustomerPartner;

  get address() {
    const address = new PostalAddress();
    address
      .setCompanyName(this.shipTo.PartnerName)
      .setAddress1(this.shipTo.StreetAndNumber)
      .setCity(this.shipTo.City)
      .setCountry(this.shipTo.CountryKey)
      .setPostalCode(this.shipTo.PostalCode);
    return address.output().map((line: string[]) => line.join(' '));
  }
}
